export default "__VITE_ASSET__t_Fv5sCr__"